import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

interface HistoryCheckModalData {
  title?: string;
}

type HistoryCheckModalProviderProps = {
  children: ReactNode;
};

type HistoryCheckModalContextValue = {
  isHistoryCheckModalOpen: boolean;
  setIsHistoryCheckModalOpen: (open: boolean) => void;
  historyCheckModalData: HistoryCheckModalData | undefined;
  setHistoryCheckModalData: (data: HistoryCheckModalData | undefined) => void;
};

const HistoryCheckModalContext = createContext<HistoryCheckModalContextValue>({
  isHistoryCheckModalOpen: false,
  setIsHistoryCheckModalOpen: () => null,
  historyCheckModalData: undefined,
  setHistoryCheckModalData: () => null,
});

const HistoryCheckModalProvider = ({
  children,
}: HistoryCheckModalProviderProps) => {
  const [isHistoryCheckModalOpen, setIsHistoryCheckModalOpen] =
    useState<boolean>(false);
  const [historyCheckModalData, setHistoryCheckModalData] = useState<
    HistoryCheckModalData | undefined
  >(undefined);

  const value = useMemo(
    () => ({
      isHistoryCheckModalOpen,
      setIsHistoryCheckModalOpen,
      historyCheckModalData,
      setHistoryCheckModalData,
    }),
    [isHistoryCheckModalOpen, historyCheckModalData],
  );

  return (
    <HistoryCheckModalContext.Provider value={value}>
      {children}
    </HistoryCheckModalContext.Provider>
  );
};

const useHistoryCheckModal = () => useContext(HistoryCheckModalContext);

export { HistoryCheckModalProvider, useHistoryCheckModal };
